import React from 'react';
import { Box, Container, Typography } from '@mui/material';

/**
 * Kopfzeile (§7 des Plans): Logo links, Titel „Regionen-Demo".
 * Keine Sprachumschaltung — die Oberfläche ist ausschließlich deutsch.
 */
const Masthead: React.FC = () => (
  <Box className="masthead" component="header">
    <Container maxWidth={false} className="masthead-inner">
      <Box className="masthead-titles">
        <Typography variant="h1" className="masthead-title">
          Field Level Information System
        </Typography>
        <Typography className="masthead-subtitle">
          Rheinland-Pfalz — Zustandsklasse Mais — Zeitraum 1.–15. Juli 2026
        </Typography>
      </Box>
      <Box className="brand-block">
        <Box component="img" src="/logo_CORAmaps.png" alt="CORAmaps" className="brand-logo" />
      </Box>
    </Container>
  </Box>
);

export default Masthead;
